// extracted by mini-css-extract-plugin
module.exports = {"title":"idt-photoprintoptiongrouptitle_title__1apwp","header":"idt-photoprintoptiongrouptitle_header__3-vpg","inlineFlex":"idt-photoprintoptiongrouptitle_inlineflex__1knvw"};